import { API_BASE_URL } from './config';

// 获取可用时间段
export async function fetchAvailableSlots(date) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/slots?date=${date}`);
    if (!response.ok) {
      throw new Error('Failed to fetch slots');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching slots:', error);
    throw error;
  }
}

// 预约时间段
export async function bookAppointment(appointmentData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/appointments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(appointmentData),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to book appointment');
    }
    return data;
  } catch (error) {
    console.error('Error booking appointment:', error);
    throw error;
  }
}

// 获取预约详情
export async function fetchAppointment(id, phone) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/appointments/${id}?phone=${phone}`);
    if (!response.ok) {
      throw new Error('Failed to fetch appointment');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching appointment:', error);
    throw error;
  }
}

// 管理员登录
export async function adminLogin(password) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password }),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Login failed');
    }
    return data;
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
}

// 管理员获取预约列表
export async function fetchAdminAppointments(date, token) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/appointments?date=${date}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching admin appointments:', error);
    throw error;
  }
}

// 更新可用性设置
export async function updateAvailability(date, settings, token) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/availability`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ date, settings }),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to update availability');
    }
    return data;
  } catch (error) {
    console.error('Error updating availability:', error);
    throw error;
  }
}

export const updateAppointment = async (id, appointmentData) => {
  const response = await fetch(`${API_BASE_URL}/api/appointments/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(appointmentData),
  });
  
  return await response.json();
};

export const cancelAppointment = async (id, phone) => {
  const response = await fetch(`${API_BASE_URL}/api/appointments/${id}?phone=${encodeURIComponent(phone)}`, {
    method: 'DELETE',
  });
  
  return await response.json();
};